import { Observable } from 'rxjs';

export interface Facility {
  id: number;
  name: string;
}

export abstract class FacilityData {
  abstract list(): Observable<Facility[]>;
}
